import React from "react";

function Progress() {
  return (
    <>
      <div className="temp-text">
        <h1>In Progress</h1>
      </div>
    </>
  );
}

export default Progress;
